export const isTelegramWebApp = (): boolean => {
  const tg = (window as any)?.Telegram?.WebApp;
  const initData: string = tg?.initData ?? "";
  return Boolean(tg && initData.trim().length > 0);
};

export const getTelegramInitData = (): string => {
  const tg = (window as any)?.Telegram?.WebApp;
  return (tg?.initData ?? "").toString();
};

export const prepareTelegramWebApp = (): void => {
  const tg = (window as any)?.Telegram?.WebApp;
  if (!tg) return;

  try {
    const viewportMeta = document.querySelector('meta[name="viewport"]');
    viewportMeta?.setAttribute(
      "content",
      "width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, viewport-fit=cover"
    );

    if (!(window as any).__tgZoomLocked) {
      const preventGestureZoom = (event: Event) => event.preventDefault();
      document.addEventListener("gesturestart", preventGestureZoom, {
        passive: false,
      });
      document.addEventListener("gesturechange", preventGestureZoom, {
        passive: false,
      });
      document.addEventListener("gestureend", preventGestureZoom, {
        passive: false,
      });
      (window as any).__tgZoomLocked = true;
    }

    tg.ready?.();
    tg.expand?.();

    // For launches via /start keyboard button, force expanded (fullsize) mode.
    const tryExpand = () => {
      tg.expand?.();
    };

    tryExpand();
    window.setTimeout(tryExpand, 120);
    window.setTimeout(tryExpand, 360);

    tg.disableVerticalSwipes?.();
  } catch (e) {
    console.warn("Telegram WebApp prepare failed", e);
  }
};

export const hasTelegramWebApp = (): boolean =>
  Boolean((window as any)?.Telegram?.WebApp);

/**
 * Ждёт появления initData внутри Telegram.
 *
 * При холодном старте мини-приложения Telegram отдаёт initData не мгновенно:
 * если проверить сразу, строка окажется пустой, приложение решит, что открыто
 * в обычном браузере, и покажет интерфейс неавторизованного пользователя —
 * тот самый случай «открыл бота, всё сломано, после перезагрузки работает».
 *
 * Возвращает initData или пустую строку, если это действительно не Telegram.
 */
export const waitForTelegramInitData = async (
  timeoutMs = 3000,
  stepMs = 100
): Promise<string> => {
  if (!hasTelegramWebApp()) {
    return "";
  }

  const deadline = Date.now() + timeoutMs;

  // eslint-disable-next-line no-constant-condition
  while (true) {
    const initData = getTelegramInitData().trim();

    if (initData) {
      return initData;
    }

    if (Date.now() >= deadline) {
      return "";
    }

    await new Promise((resolve) => window.setTimeout(resolve, stepMs));
  }
};

export const isTelegramWebView = (): boolean =>
  Boolean((window as any)?.Telegram?.WebApp && /Telegram|TGWebView/i.test(navigator.userAgent ?? ""));
